module.exports = __webpack_public_path__ + "images/b732beb8.jpg";